/**
 * 라우트 관련 store
 */
const router = {
  state: {
    /* tree */
    /**
     * 현재 선택된 트리 노드의 메뉴
     * @type {String}
     */
    treeMenu: null,
    /**
     * 현재 선택된 트리 노드의 트리 타입
     * @type {String}
     */
    treeType: null,
    /* tab */
    /**
     * 라우트할 탭
     * @type {String}
     */
    tmpActiveTab: null,
    /**
     * 링크를 통해 라우트가 전환 됐는지 여부.
     * 논리/물리 그룹 트리 기준으로 라우트될 때 만 설정한다.
     * @type {Boolean}
     */
    isLinkRoute: false,
  },
  mutations: {
    setTmpActiveTab: (state, activeTab) => {
      state.tmpActiveTab = activeTab;
    },
    setTreeMenu: (state, treeMenu) => {
      state.treeMenu = treeMenu;
    },
    setTreeType: (state, treeType) => {
      state.treeType = treeType;
    },
    setIsLinkRoute: (state, value) => {
      state.isLinkRoute = value;
    },
  },
  actions: {
    setTmpActiveTab({ commit }, activeTab) {
      commit('setTmpActiveTab', activeTab);
    },
    setTreeMenu({ commit }, treeMenu) {
      commit('setTreeMenu', treeMenu);
    },
    setTreeType({ commit }, treeType) {
      commit('setTreeType', treeType);
    },
    setIsLinkRoute({ commit }, value) {
      commit('setIsLinkRoute', value);
    },
  },
};

export default router;



// WEBPACK FOOTER //
// ./src/store/modules/router.js